var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnderline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 12.1372H13V13H4V12.1372Z",
    fill: "#002A69"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9095 3H12V8.33878C12 8.88998 11.8549 9.38212 11.5647 9.81521C11.2774 10.2457 10.8714 10.5856 10.3467 10.8349C9.82203 11.0817 9.20645 11.205 8.5 11.205C7.79355 11.205 7.17797 11.0817 6.65327 10.8349C6.12856 10.5856 5.72111 10.2457 5.4309 9.81521C5.14363 9.38212 5 8.88998 5 8.33878V3H6.09045V8.26003C6.09045 8.65375 6.18719 9.00416 6.38065 9.31125C6.57412 9.61573 6.84967 9.85589 7.20729 10.0318C7.56784 10.205 7.99874 10.2916 8.5 10.2916C9.00126 10.2916 9.43216 10.205 9.79271 10.0318C10.1533 9.85589 10.4288 9.61573 10.6193 9.31125C10.8128 9.00416 10.9095 8.65375 10.9095 8.26003V3Z",
    fill: "#002A69"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnderline);
export default __webpack_public_path__ + "static/media/Underline.ddff163d9f7387b930f623325089d4e9.svg";
export { ForwardRef as ReactComponent };